export default "__VITE_ASSET__b385878d__"